import { createReducer } from "reduxsauce";

import ReducerRegister from "../../ReducerRegister";
import LoginService from "../../../services/screens/account/LoginService";
import { ActionTypes } from "../../actionTypes/screens/account/LoginActionTypes";
import AsyncActionReducers from "../../AsyncActionReducers";

import UIDs from "../../../UIDs";

const uid = UIDs.screens.account.login;

//
// Actions
//
const Actions = {
    loginAsync: (email, password, userTableType) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOGIN_ASYNC, email, password, userTableType });

            LoginService.Login(
                email,
                password,
                userTableType,
                response => {
                    dispatch(Actions.loginSuccess(response));
                },
                error => {
                    dispatch(Actions.loginFailure(error));
                }
            );
        };
    },

    loginSuccess: (data) => ({
        type: ActionTypes.LOGIN_SUCCESS,
        parentType: ActionTypes.LOGIN_ASYNC,
        data,
    }),

    loginFailure: error => ({
        type: ActionTypes.LOGIN_FAILURE,
        parentType: ActionTypes.LOGIN_ASYNC,
        error
    }),
    
    changePasswordAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.CHANGE_PASSWORD_ASYNC, vo });

            LoginService.changePassword(
                vo,
                response => {
                    dispatch(Actions.changePasswordSuccess(response));
                },
                error => {
                    dispatch(Actions.changePasswordFailure(error));
                }
            );
        };
    },

    changePasswordSuccess: data => ({
        type: ActionTypes.CHANGE_PASSWORD_SUCCESS,
        parentType: ActionTypes.RESET_PASSWORD_ASYNC,
        data
    }),

    changePasswordFailure: error => ({
        type: ActionTypes.CHANGE_PASSWORD_FAILURE,
        parentType: ActionTypes.CHANGE_PASSWORD_ASYNC,
        error
    }),
    
    toggleModal: () => ({
        type: ActionTypes.TOGGLE_MODAL,
    }),

    updateSettings: (newData) => ({
        type: ActionTypes.UPDATE_SETTINGS,       
        newData
    }),

};

//
// Initial State
//
const INITIAL_STATE = {
    isFirstLogin: false,
    resetPasswordVo:{
       newPassword: "",
       confirmPassword: "",
       errorMessage: "",
    }
};

//
// Reducers
//
const toggleModalReducer = (state, value) => {
    return { ...state, isFirstLogin: value, resetPasswordVo: { ...state.resetPasswordVo, errorMessage: ""}};
};

const updateSettingsReducer = (state, { newData }) => {
    return { ...state, resetPasswordVo: newData, };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOGIN_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOGIN_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOGIN_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.CHANGE_PASSWORD_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.CHANGE_PASSWORD_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.CHANGE_PASSWORD_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.TOGGLE_MODAL]: toggleModalReducer,
    [ActionTypes.UPDATE_SETTINGS]: updateSettingsReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };